// extracted by mini-css-extract-plugin
export var $animation_name = "Button-module--$animation_name--23368";
export var button = "Button-module--button--6a870";
export var button__icon = "Button-module--button__icon--d6500";
export var button__link = "Button-module--button__link--0bc11";